import { Snackbar, Alert, Backdrop, CircularProgress } from "@mui/material";
import { useState } from "react";

// react-router-dom components
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useIsAuthenticated } from "react-auth-kit";

// @mui material components
import Card from "@mui/material/Card";
// import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Authentication layout components
import BasicLayout from "app/user/components/BasicLayoutSignUp";

// Images
import bgImage from "assets/images/bg-sign-up-cover.jpeg";

// import axios from "axios.js";

// import { Formik } from "formik";
// import * as Yup from "yup";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

function ContactInfo() {
  const title = "Sign Up | Contact Information";
  usePageTitle(title);

  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  if (isAuthenticated()) {
    navigate("/dashboard");
  }

  const location = useLocation();
  console.log(location);
  if (location.state !== null) {
    if (typeof location.state.company === "undefined") {
      navigate("/sign-up");
    }
  } else {
    navigate("/sign-up");
  }

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [lastName, setLastName] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [password, setPassword] = useState(null);
  const [cPassword, setCPassword] = useState(null);

  function next() {
    if (lastName === null || lastName === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Campany name is required.");
      setSeverity("error");
      return;
    }

    if (firstName === null || firstName === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Campany name is required.");
      setSeverity("error");
      return;
    }

    if (emailAddress === null || emailAddress === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Campany email is required.");
      setSeverity("error");
      return;
    }
    if (phoneNumber === null || phoneNumber === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Campany phone number is required.");
      setSeverity("error");
      return;
    }
    if (password === null || password === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Campany address is required.");
      setSeverity("error");
      return;
    }

    if (cPassword === password) {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Campany industry is required.");
      setSeverity("error");
      return;
    }

    const companyPayload = location.company;
    const payload = {
      company: companyPayload,
      contact: {
        last_name: lastName,
        first_name: firstName,
        email_address: emailAddress,
        phone_number: phoneNumber,
        password: `${password}`,
      },
    };
    navigate("/sign-up/otp", payload);
  }

  return (
    <BasicLayout image={bgImage}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox>
        <MDBox mb={3} mt={5}>
          <Card>
            <MDBox
              bgColor={AppConfig.sidenav_active_menu_color}
              borderRadius="lg"
              coloredShadow="info"
              mx={5}
              mt={-3}
              p={2}
              mb={3}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                Laddar Africa
              </MDTypography>
            </MDBox>
          </Card>
        </MDBox>
        <MDBox mb={3} mt={5}>
          <Card>
            <MDBox pt={4} pb={3} px={3}>
              <MDTypography variant="h6" fontWeight="medium">
                Contact Information
              </MDTypography>
              <MDTypography variant="h6" fontWeight="light">
                Enter your personal details
              </MDTypography>
              <MDBox mt={3}>
                <MDBox mb={3}>
                  <MDInput
                    type="text"
                    label="Last Name"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </MDBox>
                <MDBox mb={3}>
                  <MDInput
                    type="text"
                    label="First Name"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </MDBox>
                <MDBox mb={3}>
                  <MDInput
                    type="text"
                    label="Email Address"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setEmailAddress(e.target.value)}
                  />
                </MDBox>
                <MDBox mb={3}>
                  <MDInput
                    type="text"
                    label="Phone Number"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </MDBox>
                <MDBox mb={3}>
                  <MDInput
                    type="password"
                    label="Password"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </MDBox>
                <MDBox mb={3}>
                  <MDInput
                    type="password"
                    label="Repeat Password"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setCPassword(e.target.value)}
                  />
                </MDBox>

                <MDBox align="right">
                  <MDBox mt={4} mb={1}>
                    <MDButton
                      variant="outlined"
                      color={AppConfig.sidenav_active_menu_color}
                      onClick={() => navigate("/sign-up")}
                    >
                      Start Over
                    </MDButton>
                    &nbsp;
                    <MDButton
                      variant="gradient"
                      color={AppConfig.sidenav_active_menu_color}
                      onClick={() => next()}
                    >
                      Next
                    </MDButton>
                  </MDBox>
                  <MDBox mt={3} mb={1} textAlign="center">
                    <MDTypography variant="button" color="text">
                      Already have an account?{" "}
                      <MDTypography
                        component={Link}
                        to="/sign-in"
                        variant="button"
                        color={AppConfig.sidenav_active_menu_color}
                        fontWeight="medium"
                        textGradient
                      >
                        Sign In
                      </MDTypography>
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>
    </BasicLayout>
  );
}

export default ContactInfo;
